import { t as lnT } from '../i18n';
import {useTranslation} from 'react-i18next';
import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { PALE_WHITE_6 } from '../appearance/Colors';

import { Waypoint } from 'react-waypoint';

const useKeyPress = function (targetKey) {
    const [keyPressed, setKeyPressed] = useState(false);

    function downHandler(event) {
        if (event.key === targetKey) {
            event.preventDefault();
            setKeyPressed(true);
        }
    }

    const upHandler = event => {
        if (event.key === targetKey) {
            event.preventDefault();
            setKeyPressed(false);
        }
    };

    React.useEffect(() => {
        window.addEventListener('keydown', downHandler);
        window.addEventListener('keyup', upHandler);

        return () => {
            window.removeEventListener('keydown', downHandler);
            window.removeEventListener('keyup', upHandler);
        };
    });

    return keyPressed;
};

// const items = [
// 	{ id: 1, name: 'Josh Weir' },
// 	{ id: 2, name: 'Sarah Weir' },
// 	{ id: 3, name: 'Alicia Weir' },
// 	{ id: 4, name: 'Doo Weir' },
// 	{ id: 5, name: 'Grooft Weir' }
// ];

const renderWaypoint = (i, items, loadMore) => {
    // console.log('waypoint entered', i);
    // console.log('hello', data.getFolderContent.messages.messages.length);
    // console.log('hello 3', data.getFolderContent.messages.messages.length - 3);
    if (items.length > 2) {
        // console.log('this is the size');
        if (i === items.length - 3) {
            return <Waypoint onEnter={() => loadMore()} />;
        } else {
            return null;
        }
    }
};

const ListItem = ({ item, items, active, index, setSelected, setHovered, currentItem, loadMore, variant }) => (
    <div
        key={index}
        className={`item ${active ? 'active' : ''}`}
        onClick={() => setSelected(item)}
        onMouseEnter={() => setHovered(item)}
        onMouseLeave={() => setHovered(undefined)}
        style={{
            color: 'white',
            cursor: 'pointer',
            paddingLeft: variant === 'folderCards' ? 14 : 12,
            paddingRight: variant === 'folderCards' ? 14 : 12,
            paddingTop: variant === 'folderCards' ? 10 : 8,
            paddingBottom: variant === 'folderCards' ? 10 : 8,
            marginBottom: variant === 'folderCards' ? 4 : 2,
            marginTop: variant === 'folderCards' ? 4 : 2,
            borderRadius: variant === 'folderCards' ? 14 : 12,
            border: variant === 'folderCards'
                ? `1px solid ${active ? 'rgba(255,255,255,0.28)' : 'rgba(255,255,255,0.14)'}`
                : '1px solid transparent',
            backgroundColor: active
                ? variant === 'folderCards' ? 'rgba(255,255,255,0.08)' : 'rgba(255,255,255,.2)'
                : variant === 'folderCards' ? 'rgba(255,255,255,0.025)' : 'transparent',
            minHeight: 55,
            transition: 'background 0.15s ease, border-color 0.15s ease'
        }}
    >
        <div style={{ display: 'flex', flexDirection: 'row' }}>
            <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', flex: 1, minWidth: 0 }}>
                {item._ResultIcon ? (
                    <span style={{
                        width: 24,
                        height: 24,
                        marginRight: 10,
                        borderRadius: 6,
                        display: 'inline-flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        color: item._ResultIconColor || 'rgba(255,255,255,.84)',
                        backgroundColor: 'rgba(255,255,255,.07)',
                        flex: '0 0 auto'
                    }}>
                        {React.createElement(item._ResultIcon, { size: 14, 'aria-hidden': true })}
                    </span>
                ) : null}
                <div style={{ display: 'flex', flexDirection: 'column', flex: 1, minWidth: 0 }}>
                    <span style={{ marginRight: 8, fontWeight: variant === 'folderCards' ? 600 : 400 }}>{item.title}</span>
                    {item.path ? (
                        <span style={{ marginRight: 8, marginTop: variant === 'folderCards' ? 4 : 8, color: 'rgba(255,255,255,.4)', fontSize: 12 }}>
                            {item.path}
                        </span>
                    ) : null}
                </div>
            </div>
            {currentItem && item.id === currentItem.id ? (
                <div>
                    <span style={{ fontSize: 12, opacity: 0.6 }}>{lnT('folders:current')}</span>
                </div>
            ) : item._isAiSuggestion ? (
                <div style={{ 
                    backgroundColor: 'rgba(43, 136, 217, 0.2)', 
                    padding: '2px 8px', 
                    borderRadius: '4px',
                    height: 'fit-content',
                    border: '1px solid rgba(43, 136, 217, 0.4)'
                }}>
                    <span style={{ fontSize: 10, color: '#7dc1f2', fontWeight: 'bold' }}>{lnT('common:aiSuggestion')}</span>
                </div>
            ) : null}
        </div>
        {renderWaypoint(index, items, loadMore)}
    </div>
);

const SelectableList = ({ items, selectedItem, currentItem, loadMore, variant = 'default' }) => {
    const {t: lnT} = useTranslation();

    const [selected, setSelected] = useState(undefined);
    const downPress = useKeyPress('ArrowDown');
    const upPress = useKeyPress('ArrowUp');
    const enterPress = useKeyPress('Enter');
    const [cursor, setCursor] = useState(0);
    const [hovered, setHovered] = useState(undefined);

    useEffect(() => {
        setCursor(0);
    }, [items]);

    useEffect(() => {
        if (items.length && downPress) {
            setCursor(prevState => (prevState < items.length - 1 ? prevState + 1 : prevState));
            if (items.length - 1 === cursor) {
                setCursor(0);
            }
        }
    }, [downPress]);

    useEffect(() => {
        if (items.length && upPress) {
            setCursor(prevState => (prevState > 0 ? prevState - 1 : prevState));
            if (cursor === 0) {
                setCursor(items.length - 1);
            }
        }
    }, [upPress]);

    useEffect(() => {
        if (items.length && enterPress) {
            setSelected(items[cursor]);
            selectedItem(items[cursor]);
        }
    }, [cursor, enterPress]);

    useEffect(() => {
        if (items.length && hovered) {
            setCursor(items.indexOf(hovered));
        }
    }, [hovered]);

    return (
        <div>
            {/* <span>Selected: {selected ? selected.title : 'none'}</span> */}
            {items.map((item, i) => (
                <ListItem
                    currentItem={currentItem}
                    key={item.id}
                    index={i}
                    active={i === cursor}
                    item={item}
                    items={items}
                    setSelected={value => {
                        setSelected(value);
                        selectedItem(value);
                    }}
                    setHovered={setHovered}
                    loadMore={loadMore}
                    variant={variant}
                />
            ))}
            {items.length === 0 ? <NoResults>{lnT('common:noSuchFolderFound')}</NoResults> : null}
            {/* <p>
				<small>
					Use up down keys and hit enter to select, or use the mouse
				</small>
			</p> */}
        </div>
    );
};

const NoResults = styled.div`
    display: flex;
    justify-content: center;
    color: ${PALE_WHITE_6};
    margin-top: 16px;
`;

export default SelectableList;
